export default {
  translateLangCheck: {
    title: "Literal constants check",
    close: "Close",
    checking: "Checking literal constants…",
    requestError: "Request failed",
    noViolations: "No violations found.",
    noLanguageTag: "(no tag)",
    columns: {
      subject: "Subject",
      predicate: "Predicate",
      language: "Language",
      count: "Count",
      violation: "Violation"
    }
  },
  uriReplacement: {
    title: "Replace URI",
    cancel: "Cancel",
    replace: "Replace",
    sourceUri: "Source URI",
    targetUri: "Target URI",
    invalidSourceUri: "The source URI has an invalid format.",
    invalidTargetUri: "The target URI has an invalid format.",
    urisMustDiffer: "The source and target URIs must be different.",
    positions: "Replace URI in positions:",
    subjects: "Subjects ({{count}})",
    predicates: "Predicates ({{count}})",
    objects: "Objects ({{count}})",
    checkingUsage: "Checking URI usage…",
    backupWarning: "Archiving the data before replacing the URI is recommended.",
    error: "Error",
    success: "URI replacement completed."
  },
  conceptUriReplacement: {
    title: "Replace concept URI",
    inScheme: "Linked to a concept scheme",
    notInScheme: "Not linked to a concept scheme",
    sourceMode: "Source URI input method",
    selectConcept: "Select concept",
    enterManually: "Enter manually",
    concept: "Concept",
    selectSourceUri: "Select the source URI",
    loadError: "Could not load the concept list"
  }
}
